import { Component, Input, OnInit, QueryList, ViewChildren } from '@angular/core';
import { UserSessionService } from './../../../UserSession/user-session.service';
import { CustomformComponent } from '../customform/customform.component';
import { ExcelExporterService } from './../../../excel-exporter.service';

@Component({
  selector: 'ngx-subform',
  templateUrl: './subform.component.html',
  styleUrls: ['./subform.component.scss']
})
export class SubformComponent implements OnInit {



  public customform: any;
  public subformRecords: Array<any>
  constructor(private userSessionService: UserSessionService,private excelService: ExcelExporterService) { }

  public ocurrencies: number


  public fieldId: string;

  @Input()
  public subformTitle: string;

  @Input()
  public editionEnabled: boolean;

  @Input()
  public set loadSubform(val:any){

    console.log('Inicializando subform')
    this.ocurrencies = val.subformConfig.ocurrencies
    this.fieldId = val.key
    this.userSessionService.getCustomForm(val.subformConfig.id).subscribe(async (customform) => {
        this.customform = customform;
       this.loadSubformRecords(val.value)

    })
  }

  @ViewChildren("ocurrency") private customformList: QueryList<CustomformComponent>;

  private loadSubformRecords(records) {
        if(this.ocurrencies > 0){

          while(records.length < this.ocurrencies){
            records.push(this.generateEmptyRecord())
          }


        }
          this.subformRecords = records;

  }

  ngOnInit(): void {
  }

  generateEmptyRecord(){
    var record = {}
    this.customform.dynamic_form.Fields.forEach(f => {
      record[f.id] = '';
      if(f.multiselect){
        record[f.id] = [];
      }
    })
    return record;
  }

  public deleteOccurency(index){
      this.subformRecords.splice(index,1)
  }


  public addOcurrency(){

    //Cogemos el ultimo
    var rellenado = false;

    if(this.subformRecords.length == 0){
      rellenado = true;
    }else{
      var ultimoValor = this.customformList.last.saveReport();
      var claves = Object.keys(ultimoValor);

      claves.forEach( k=> {
        if(ultimoValor[k] != undefined && ultimoValor[k] != null && ultimoValor[k]!= '' && ultimoValor[k]!= '0.00' ){
          rellenado = true;
        }
      })
    }


    if(rellenado){
      this.subformRecords.push(this.generateEmptyRecord())
    }
  }

  getValue(): any {
    return this.customformList.map( inst => {
      return inst.saveReport();
    }).map(r => {
      this.excelService.validarSingleCustomForm(this.customform,r,null,null,this.subformTitle+' - ');
      return r
    })
  }


}
